import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";

/**
 * Titles for Shopify ids. Rules store gids because that is what the discount
 * function matches on, so anything showing them to a merchant needs this.
 */
export const useCatalogLabels = (gids: readonly string[]) => {
	const wanted = [...new Set(gids.filter((gid) => gid.startsWith("gid://")))].sort();

	return useQuery({
		queryKey: ["catalog-labels", wanted.join(",")],
		queryFn: () =>
			api.get<{ labels: Record<string, string> }>(
				`/api/catalog/labels?gids=${encodeURIComponent(wanted.join(","))}`,
			),
		enabled: wanted.length > 0,
		staleTime: 5 * 60 * 1000,
	});
};
